import React from 'react'

interface Props {
  id?: string
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'p' | 'span'
  title?: string
  editMode?: boolean
  className?: string
}

const EditableTitle = (props: Props) => {
  const {
    variant = 'h2',
    title = undefined,
    editMode = false,
    id = undefined,
    className = '',
  } = props

  return !!title || editMode ? (
    editMode ? (
      <div className={className} id={id}>
        {title}
      </div>
    ) : variant === 'h3' ? (
      <h3 className={className} id={id}>
        {title}
      </h3>
    ) : variant === 'h4' ? (
      <h4 className={className} id={id}>
        {title}
      </h4>
    ) : variant === 'p' ? (
      <p className={className} id={id}>
        {title}
      </p>
    ) : variant === 'span' ? (
      <span className={className} id={id}>
        {title}
      </span>
    ) : variant === 'h1' ? (
      <h1 className={className} id={id}>
        {title}
      </h1>
    ) : (
      <h2 className={className} id={id}>
        {title}
      </h2>
    )
  ) : (
    <></>
  )
}

export default EditableTitle
